import * as actions from '../Actions/actionTypes';

const initialState = {
  error: null,
  loading: false,
  verifyEmail: { error: null, loading: false },
  recoverPassword: { error: null, loading: false },
  profileEdit: { error: null, loading: false },
  deleteUser: { error: null, loading: false },
};

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actions.CLEAN_UP:
      return initialState;
    case actions.AUTH_START:
      return { ...state, loading: true, error: null };
    case actions.AUTH_END:
      return { ...state, loading: false };
    case actions.AUTH_SUCCESS:
      return { ...state, error: false };
    case actions.AUTH_FAIL:
      return { ...state, error: payload };
    case actions.VERIFY_START:
      return { ...state, verifyEmail: { error: null, loading: true } };
    case actions.VERIFY_SUCCESS:
      return { ...state, verifyEmail: { error: false, loading: false } };
    case actions.VERIFY_FAIL:
      return { ...state, verifyEmail: { error: payload, loading: false } };
    case actions.RECOVERY_START:
      return { ...state, recoverPassword: { error: null, loading: true } };
    case actions.RECOVERY_SUCCESS:
      return { ...state, recoverPassword: { error: false, loading: false } };
    case actions.RECOVERY_FAIL:
      return { ...state, recoverPassword: { error: payload, loading: false } };
    case actions.PROFILE_EDIT_START:
      return { ...state, profileEdit: { error: null, loading: true } };
    case actions.PROFILE_EDIT_SUCCESS:
      return { ...state, profileEdit: { error: false, loading: false } };
    case actions.PROFILE_EDIT_FAIL:
      return { ...state, profileEdit: { error: payload, loading: false } };
    case actions.DELETE_START:
      return { ...state, deleteUser: { error: null, loading: true } };
    case actions.DELETE_SUCCESS:
      return { ...state, deleteUser: { error: false, loading: false } };
    case actions.DELETE_FAIL:
      return { ...state, deleteUser: { error: payload, loading: false } };
    default:
      return state;
  }
};

export default authReducer;
